import React, { createContext } from "react";

const WorkspaceContext = createContext({});

export default WorkspaceContext;
